import React from 'react';
import { View } from 'react-native';
import { Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';

import './NotificationBubble.module.scss';

const NotificationBubble = ({
  children,
  testID,
}: {
  children: React.ReactNode,
  testID: string,
}) => (
  <Inline
    style={{
      position: 'absolute',
      left: 0,
      bottom: 58,
      width: '80vw',
    }}
    flexShrink={1}
    testID={testID}
  >
    <Inline
      color={colors.chill}
      padding={8}
      alignItems="flex-end"
      space={16}
      flexWrap="nowrap"
      flexShrink={1}
      styleName="boxShadow"
    >
      {children}
    </Inline>
    <View
      style={{
        position: 'absolute',
        bottom: -12,
        left: 12,
        borderWidth: 6,
        borderStyle: 'solid',
        borderColor: 'transparent',
        borderTopColor: colors.chill,
      }}
    />
  </Inline>
);

export default NotificationBubble;
